import type { BoardDoc } from '../doc/BoardDoc';
import type { PaneStore } from './paneStore';

/** Mounted panes by their root element, so a drag can find the pane under the pointer (split view). */
const panes = new Map<Element, { board: BoardDoc; pane: PaneStore }>();

export function registerPane(el: Element, entry: { board: BoardDoc; pane: PaneStore }): () => void {
  panes.set(el, entry);
  return () => {
    if (panes.get(el) === entry) panes.delete(el);
  };
}

export function paneAt(clientX: number, clientY: number): { el: Element; board: BoardDoc; pane: PaneStore } | null {
  const el = document.elementFromPoint(clientX, clientY)?.closest('.pane');
  if (!el) return null;
  const entry = panes.get(el);
  return entry ? { el, ...entry } : null;
}
